import {
  Container,
  Section,
  Heading,
  Lede,
  Eyebrow,
  Card,
  LinkButton,
} from "../components/ui";
import { useSeo } from "../lib/seo";

export function About() {
  useSeo({
    title: "About — WeConsult Rx",
    description:
      "WeConsult Rx is a DRX Consulting Group product. Built by consultant pharmacists and software engineers. Forest green from day one.",
    path: "/about",
  });

  return (
    <>
      <Section>
        <Container>
          <div className="max-w-3xl">
            <Eyebrow>About</Eyebrow>
            <Heading level={1} className="mt-3">
              Built by consultant pharmacists. Coded by engineers who care.
            </Heading>
            <Lede className="mt-6">
              WeConsult Rx is the operating system we wish we’d had when we
              started consulting. Evidence-cited rules. Audit-ready workflows.
              No spreadsheets.
            </Lede>
          </div>
        </Container>
      </Section>

      <Section tone="soft">
        <Container>
          <div className="grid gap-10 md:grid-cols-2">
            <div>
              <Heading level={2}>Our mission</Heading>
              <p className="mt-4 text-ink-700">
                Modernize consultant pharmacy operations so practitioners can
                spend their time on clinical judgment — not chart-shuffling.
              </p>
              <p className="mt-4 text-ink-700">
                We codify every regulatory standard worth following. We
                fingerprint every recommendation with its citation. We ship
                workflows that survive surveyor scrutiny.
              </p>
            </div>
            <div>
              <Heading level={2}>How we work</Heading>
              <ul className="mt-4 space-y-3 text-ink-700">
                <li>
                  <strong>Evidence first:</strong> Every clinical rule cites its
                  source. No “AI told me so.”
                </li>
                <li>
                  <strong>HIPAA in code:</strong> 68 PHI safety gates locked
                  into our test suite. RLS pen-test on every commit.
                </li>
                <li>
                  <strong>Customer-shaped:</strong> Direct feedback from
                  consultant pharmacists drives the roadmap.
                </li>
              </ul>
            </div>
          </div>
        </Container>
      </Section>

      <Section>
        <Container>
          <Heading level={2}>Parent company</Heading>
          <p className="mt-4 text-ink-700 max-w-3xl">
            WeConsult Rx is a product of <strong>DRX Consulting Group</strong>,
            a consultant pharmacy practice serving SNF, ASC, and dialysis
            facilities since 2014.
          </p>
          <div className="mt-8 grid gap-6 md:grid-cols-3">
            {[
              ["10+ years", "Consultant pharmacy practice"],
              ["3 verticals", "SNF · ASC · Dialysis"],
              ["49 rules", "Codified and citation-anchored"],
            ].map(([k, v]) => (
              <Card key={k}>
                <p className="text-3xl font-extrabold text-forest-700 tracking-tightest">{k}</p>
                <p className="mt-2 text-ink-700">{v}</p>
              </Card>
            ))}
          </div>
          <div className="mt-10">
            <LinkButton to="/contact" variant="secondary">
              Talk to the team
            </LinkButton>
          </div>
        </Container>
      </Section>
    </>
  );
}
